import { type JSX } from 'react/jsx-runtime';

export const EditDashboardImage = (): JSX.Element => (
	<svg width="100%" viewBox="0 0 275 132" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_449_66648)">
			<rect width="275" height="132" fill="#E9F2FE" />
			<mask id="mask0_449_66648" maskUnits="userSpaceOnUse" x="-9" y="-3" width="321" height="151">
				<path d="M311.537 -2.21094H-8.46289V147.789H311.537V-2.21094Z" fill="#F8F8F8" />
				<path d="M311.537 -2.21094H-8.46289V147.789H311.537V-2.21094Z" fill="#F8F8F8" />
			</mask>
			<g mask="url(#mask0_449_66648)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M340.537 36.415C192.258 -49.2748 2.65045 1.57494 -82.9608 149.998L47.8142 225.573C91.7243 149.446 188.977 123.363 265.033 167.315L340.537 36.415Z"
					fill="#CFE1FD"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M-216.939 72.5305C-68.6607 158.22 120.947 107.371 206.559 -41.0529L75.7836 -116.627C31.8735 -40.5009 -65.3792 -14.4173 -141.435 -58.37L-216.939 72.5305Z"
					fill="#8FB8F6"
				/>
				<path
					d="M-59.0664 114.427C33.2884 113.432 123.123 71.1259 182.299 -4.94824C89.944 -3.9537 0.109863 38.3528 -59.0664 114.427Z"
					fill="#669DF1"
				/>
			</g>
			<rect x="29.0039" y="42.2393" width="198.706" height="75.4141" rx="6" fill="white" />
			<rect x="37.4395" y="50.6748" width="58.5429" height="58.5429" rx="3.08082" fill="white" />
			<rect
				x="37.632"
				y="50.8674"
				width="58.1578"
				height="58.1578"
				rx="2.88827"
				stroke="#0B120E"
				strokeOpacity="0.14"
				strokeWidth="0.385103"
			/>
			<path d="M56.8399 70.0762H48.4043V98.7572H56.8399V70.0762Z" fill="#FFE48F" />
			<path d="M60.2145 70.0762H50.0918V98.7572H60.2145V70.0762Z" fill="#FA8700" />
			<path d="M71.1813 77.6689H61.0586V98.7579H71.1813V77.6689Z" fill="#6A9A23" />
			<path d="M81.3026 70.0762H72.0234V98.7572H81.3026V70.0762Z" fill="#D8A0F7" />
			<path d="M83.8336 70.0762H73.7109V98.7572H83.8336V70.0762Z" fill="#AF59E0" />
			<rect x="99.3574" y="50.9463" width="58" height="58" rx="3.08082" fill="#F0F1F2" />
			<rect
				x="99.8574"
				y="51.4463"
				width="57"
				height="57"
				rx="2.58082"
				stroke="#0B120E"
				strokeOpacity="0.14"
				strokeDasharray="3.04 3.04"
			/>
			<path
				d="M128.786 79.5177L128.786 75.9463L127.929 75.9463L127.929 79.5177L124.357 79.5177L124.357 80.3749L127.929 80.3749L127.929 83.9463L128.786 83.9463L128.786 80.3749L132.357 80.3749L132.357 79.5177L128.786 79.5177Z"
				fill="#6C6F77"
			/>
			<rect x="160.73" y="50.6748" width="58.5429" height="58.5429" rx="3.08082" fill="white" />
			<rect
				x="160.923"
				y="50.8674"
				width="58.1578"
				height="58.1578"
				rx="2.88827"
				stroke="#0B120E"
				strokeOpacity="0.14"
				strokeWidth="0.385103"
			/>
			<path d="M181.988 84.417H171.865V98.7575H181.988V84.417Z" fill="#B3DF72" />
			<path d="M183.673 84.417H173.551V98.7575H183.673V84.417Z" fill="#6A9A23" />
			<path d="M194.64 94.54H184.518V98.7578H194.64V94.54Z" fill="#E56E00" />
			<path d="M203.92 70.0762H195.484V98.7572H203.92V70.0762Z" fill="#D8A0F7" />
			<path d="M207.295 70.0762H197.172V98.7572H207.295V70.0762Z" fill="#964AC0" />
			<rect
				x="25"
				y="34.0479"
				width="21.4969"
				height="20.2454"
				rx="4.21779"
				transform="rotate(-6 25 34.0479)"
				fill="#1868DB"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32.068 38.8184C31.8363 38.8427 31.6682 39.0503 31.6926 39.2819L32.5743 47.6713C32.5987 47.903 32.8062 48.071 33.0379 48.0467L36.6034 47.6719L35.6334 38.4436L32.068 38.8184ZM36.8918 38.3114L37.3107 42.2963L41.2956 41.8775L40.9209 38.312C40.8965 38.0803 40.689 37.9123 40.4573 37.9366L36.8918 38.3114ZM41.4279 43.1359L37.4429 43.5547L37.8618 47.5397L41.4273 47.1649C41.6589 47.1406 41.827 46.933 41.8026 46.7014L41.4279 43.1359ZM30.4342 39.4142C30.3368 38.4875 31.009 37.6574 31.9357 37.56L40.3"
				fill="white"
			/>
			<g filter="url(#filter0_dd_449_66648)">
				<rect
					x="191.27"
					y="8.42285"
					width="66"
					height="66"
					rx="12"
					transform="rotate(13 191.27 8.42285)"
					fill="#F8F8F8"
				/>
				<path
					d="M212.115 65.4887C221.311 67.4872 228.882 62.8063 231.054 53.7778C233.319 44.3662 228.599 36.6611 219.164 34.3642C209.702 32.061 202.121 36.8103 199.95 46.399C197.769 56.0306 202.461 63.3898 212.113 65.4881L212.115 65.4887Z"
					fill="#1868DB"
				/>
				<path
					d="M217.535 49.8803L235.896 50.7268C236.596 40.8578 230.779 33.0691 220.379 30.538C220.241 30.5061 220.102 30.4768 219.966 30.4456L217.538 49.8809L217.535 49.8803Z"
					fill="#82B536"
				/>
				<path
					d="M219.452 34.5299L217.533 49.879L231.549 50.5252C232.076 42.7649 227.548 36.628 219.449 34.5293L219.452 34.5299Z"
					fill="#164B35"
				/>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_dd_449_66648"
				x="168.422"
				y="0.422852"
				width="95.1562"
				height="95.1553"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_449_66648" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
				/>
				<feBlend
					mode="normal"
					in2="effect1_dropShadow_449_66648"
					result="effect2_dropShadow_449_66648"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect2_dropShadow_449_66648"
					result="shape"
				/>
			</filter>
			<clipPath id="clip0_449_66648">
				<rect width="275" height="132" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
